'use client';

import flush from 'just-flush';
import shuffle from 'just-shuffle';
import { programsListSection } from '@stereoagency/sanity-schema';
import { SmallLinkImageCardsSection } from '@stereoagency/ui';
import { startTransition, useEffect, useState } from 'react';
import { SimpleBlockContent } from '../sanity/client';
import { linkAsProps, sanityImageAsProps } from '@/utils';

type Props = typeof programsListSection.schema.programsListSection;

export default function SimpleHero({ title, subtitle, cards }: Props) {
  const [randomizedCards, setRandomizedCards] = useState<
    typeof cardProps | null
  >(null);

  const cardProps = flush(
    cards?.map((card) => {
      if (!card.icon?.asset._ref || !card.title) {
        return null;
      }

      return {
        variant: 'image-first' as const,
        image: sanityImageAsProps(card.icon),
        title: card.title,
        description: card.description ? (
          <SimpleBlockContent value={card.description} />
        ) : null,
        action: card.action?.url ? linkAsProps(card.action) : undefined
      };
    }) ?? []
  );

  useEffect(() => {
    startTransition(() => {
      setRandomizedCards(shuffle(cardProps));
    });
  }, [cards]);

  if (!cards?.length) {
    return null;
  }

  return (
    <SmallLinkImageCardsSection
      title={title}
      subtitle={subtitle}
      cards={randomizedCards || cardProps}
    />
  );
}
